import { useMemo } from 'react';

export function usePlaceholderBasedOnConfig(customPlaceholderConfig: string | undefined) {
  const placeholder = useMemo(() => {
    const statementsToRemove = [
      'Por exemplo:',
      'Por exemplo.',
      'Por exemplo',
      'Exemplo:',
      'Exemplo.',
      'Exemplo',
      'Ex.:',
      'Ex:',
      'Ex.',
      'Ex',
    ];

    let customPlaceholder = customPlaceholderConfig;
    if (customPlaceholder) {
      statementsToRemove.forEach((s) => {
        customPlaceholder = customPlaceholder?.replace(s, '').trim();
      });
    }
    return customPlaceholder ? `Exemplo: ${customPlaceholder}` : 'Exemplo: Tirar a cebola, ponto da carne, etc...';
  }, [customPlaceholderConfig]);

  return placeholder;
}
